const API_URL = process.env.REACT_APP_API_URL || "https://vegeto-production.up.railway.app";
export default API_URL;
